export const SIDEBAR_ANIMATION_DELAY = 325;
